export function getSafeInternalPath(
  value: string | null | undefined,
): string | null {
  if (!value) {
    return null;
  }

  let path = value.trim();
  try {
    if (/^https?:\/\//i.test(path)) {
      const url = new URL(path);
      if (url.origin !== window.location.origin) {
        return null;
      }
      path = `${url.pathname}${url.search}${url.hash}`;
    }
  } catch {
    return null;
  }

  if (!path.startsWith('/') || path.startsWith('//') || path.startsWith('/\\')) {
    return null;
  }

  if (
    path.startsWith('/login') ||
    path.startsWith('/register') ||
    path.startsWith('/forgot-password')
  ) {
    return null;
  }

  return path;
}

export function loginRedirectFromLocation(): string | null {
  const params = new URLSearchParams(window.location.search);
  return getSafeInternalPath(
    params.get('redirect') || params.get('intended') || undefined,
  );
}
